//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { DataProvider, Dictionary } from "../helpers"

import { Enums } from "../models/common"
import { OpDataType, OpDataFormatGroupDetails } from "../models/core"
import { IReferenceType } from "../models/util/interfaces"
import { KeyType } from "../helpers/dictionary"

export class DataProviderDataType {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getDataType = (idDataType: Enums.DataType): JQueryPromise<OpDataType> => {
        return this
            .getDataTypes([idDataType])
            .then(result => {
                if (result && result.length > 0)
                    return result[0]
                return null
            })
    }

    public getDataTypeDict = (): JQueryPromise<Dictionary<IReferenceType>>  => {
        return this.dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(result => {
            if (result && result.containsKey(Enums.ReferenceType.IdDataType)) {
                let dataTypeDict: Dictionary<IReferenceType> = result.tryGetValue(Enums.ReferenceType.IdDataType)
                if (dataTypeDict) {
                    return dataTypeDict;
                }
            }
            else {
                return new Dictionary<IReferenceType>(null);
            }
            });
    }

    public getDataTypes = (idDataType: Enums.DataType[]): JQueryPromise<OpDataType[]> => {
        return this.dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(result => {
            if (result && result.containsKey(Enums.ReferenceType.IdDataType)) {
                var retVal: OpDataType[] = []
                var dataTypeDict: Dictionary<IReferenceType> = result.tryGetValue(Enums.ReferenceType.IdDataType)
                if (dataTypeDict && _.isArray(idDataType)) {
                    idDataType.forEach(d => {
                        if (dataTypeDict.containsKey(d))
                            retVal.push(dataTypeDict.tryGetTypedValue<OpDataType>(d))
                    })
                }
                return retVal
            }
            else
                return []
        })
    }

    public getDataTypeLocal = (idDataType: Enums.DataType): OpDataType => {
        const result: OpDataType[] = this.getDataTypesLocal([idDataType])

        if (result && result.length > 0) {
            return result[0]
        }

        return null
    }

    public getDataTypesLocal = (idDataTypes: Enums.DataType[]): OpDataType[] => {
        const result: Dictionary<Dictionary<IReferenceType>> = this.dataProvider.System.getDictionariesLocal([Enums.ReferenceType.IdDataType])

        result.setKeyType(KeyType.Number)

        if (result && result.containsKey(Enums.ReferenceType.IdDataType)) {
            const retVal: OpDataType[] = []
            const dataTypeDict: Dictionary<IReferenceType> = result.tryGetValue(Enums.ReferenceType.IdDataType)

            if (dataTypeDict) {
                if (!idDataTypes) {
                    idDataTypes = <number[]>dataTypeDict.keys()
                }

                idDataTypes.forEach((idDataType: Enums.DataType) => {
                    if (dataTypeDict.containsKey(idDataType)) {
                        retVal.push(dataTypeDict.tryGetTypedValue<OpDataType>(idDataType))
                    }
                })

                return retVal
            }
        }

        console.warn(`Unable to load datatypes for idDataTypes: [${idDataTypes}] locally.`)
        return []
    }

    public getDataTypeFormatGroup = (idDataType: number[] = null): JQueryPromise<OpDataFormatGroupDetails[]> => {
        var deferred: JQueryDeferred<OpDataFormatGroupDetails[]> = $.Deferred<OpDataFormatGroupDetails[]>()
        return this.dataProvider
            .sendRequestWithSession('OpxGetDataTypeFormatGroup', { idDataType: idDataType }, 'OpxGetDataTypeFormatGroupResult')
            .then((response: any[]) => {
                if (response) {
                    var result: OpDataFormatGroupDetails[] = response.map(opObj => new OpDataFormatGroupDetails(opObj))
                    OpDataFormatGroupDetails
                        .loadNavigationProperties(this.dataProvider, result)
                        .then(responseWithNavigationProperties => {
                            deferred.resolve(result)
                        })
                }
                else
                    deferred.resolve([])
                return deferred.promise()
            })
    }

    // Public Methods End
}